import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(date: string | Date): string {
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(date));
}

export function formatRelativeTime(date: string | Date): string {
  const now = new Date();
  const then = new Date(date);
  const diff = now.getTime() - then.getTime();

  const minutes = Math.floor(diff / (1000 * 60));
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));

  if (minutes < 60) {
    return `${minutes}m ago`;
  } else if (hours < 24) {
    return `${hours}h ago`;
  } else {
    return `${days}d ago`;
  }
}

export function generateId(): string {
  return Math.random().toString(36).substring(2) + Date.now().toString(36);
}

export function formatDuration(minutes?: number | null): string {
  if (!minutes) return "N/A";

  const totalMinutes = Math.round(minutes);

  // Calculate days, hours, minutes
  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const mins = totalMinutes % 60;

  // Format based on duration
  if (days > 0) {
    // Show days + hours + minutes (e.g., "2d 3h 45m")
    if (hours > 0 && mins > 0) {
      return `${days}d ${hours}h ${mins}m`;
    } else if (hours > 0) {
      return `${days}d ${hours}h`;
    } else if (mins > 0) {
      return `${days}d ${mins}m`;
    } else {
      return `${days}d`;
    }
  } else if (hours > 0) {
    // Show hours + minutes (e.g., "2h 30m")
    if (mins > 0) {
      return `${hours}h ${mins}m`;
    }
    return `${hours}h`;
  } else {
    // Show minutes only (e.g., "45m")
    return `${mins}m`;
  }
}
